import { render } from "./ParkedOrders.vue?vue&type=template&id=17f95feb"
import script from "./ParkedOrders.vue?vue&type=script&lang=js"
export * from "./ParkedOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__